import React from "react";

const PenWithBg: React.FC = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="6" fill="#D1A960" />
        <path
          d="M12.6906 24.2499H8.5C8.30109 24.2499 8.11033 24.1709 7.96967 24.0302C7.82902 23.8896 7.75 23.6988 7.75 23.4999V19.3093C7.74966 19.2119 7.76853 19.1154 7.80553 19.0253C7.84253 18.9352 7.89694 18.8533 7.96563 18.7843L19.2156 7.53429C19.2854 7.46343 19.3686 7.40715 19.4603 7.36874C19.5521 7.33033 19.6505 7.31055 19.75 7.31055C19.8495 7.31055 19.9479 7.33033 20.0397 7.36874C20.1314 7.40715 20.2146 7.46343 20.2844 7.53429L24.4656 11.7155C24.5365 11.7853 24.5928 11.8685 24.6312 11.9603C24.6696 12.052 24.6894 12.1505 24.6894 12.2499C24.6894 12.3494 24.6696 12.4478 24.6312 12.5396C24.5928 12.6313 24.5365 12.7145 24.4656 12.7843L13.2156 24.0343C13.1466 24.103 13.0647 24.1574 12.9746 24.1944C12.8845 24.2314 12.788 24.2503 12.6906 24.2499V24.2499Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.75 10L22 15.25"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default PenWithBg;
